const config: TourConfig = {
    title: 'Release 3.2',
    version: '3.2.x',
    contexts: {
        'edit-message-templates': [
            {
                target: () => document.querySelector('.edit-messages'),
                title: {
                    en: 'Edit your message',
                    es: 'Editar su mensaje',
                    pt: 'Editar sua mensagem',
                    fr: 'Modifier votre message',
                    ru: 'Отредактируйте свое сообщение'
                },
                description: {
                    en: 'Type in text, put desired tags by clicking on them or dragging between words',
                    es: 'Escriba texto, coloque las etiquetas deseadas haciendo clic en ellas o arrastrándolas entre palabras.',
                    pt: 'Digite o texto, insira as tags desejadas clicando nelas ou arrastando-as entre as palavras.',
                    fr: 'Saisissez du texte, insérez les balises souhaitées en cliquant dessus ou en les faisant glisser entre les mots.',
                    ru: 'Введите текст, поместите нужные теги, нажимая на них или перетаскивая между словами.'
                },
                placement: 'right-top',
                offset: [54, 0],
                width: {
                    en: 282
                },
                theme: 'dark',
                nextButton: {
                    text: {
                        en: 'Got it',
                        ru: 'Понятно',
                        es: 'Entendido',
                        fr: 'Compris',
                        pt: 'Entendi'
                    },
                    type: 'default',
                    action: ({finish}) => finish()
                }
            }
        ],
        'message-templates': [
            {
                target: () => document.querySelector('.email-preview'),
                title: {
                    en: 'Email preview',
                    es: 'Vista previa de correo electrónico',
                    pt: 'Pré-visualização de e-mail',
                    fr: "Aperçu de l'e-mail",
                    ru: 'Предварительный просмотр электронной почты'
                },
                description: {
                    en: 'Preview allows to see the email the way your customers will see it. Every change you make on the left side is reflected here.',
                    es: 'La vista previa permite ver el correo electrónico tal como lo verán sus clientes. Cada cambio que realice en el lado izquierdo se refleja aquí.',
                    pt: 'A pré-visualização permite ver o e-mail da forma como seus clientes o verão. Cada alteração que você fizer no lado esquerdo será refletida aqui.',
                    fr: 'L’aperçu permet de voir l’e-mail tel que vos clients le verront. Chaque modification effectuée sur le côté gauche est reflétée ici.',
                    ru: 'Предварительный просмотр позволяет увидеть электронное письмо так, как его увидят ваши клиенты. Каждое изменение, внесенное вами в левой части, отражается здесь.'
                },
                placement: 'top-center',
                offset: [0, -100],
                width: {
                    en: 424
                },
                theme: 'dark',
                nextButton: {
                    text: {
                        en: 'Got it',
                        ru: 'Понятно',
                        es: 'Entendido',
                        fr: 'Compris',
                        pt: 'Entendi'
                    },
                    type: 'default',
                    action: ({finish}) => finish()
                }
            }
        ]
    }
};

export default config;
